import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "pensil",
  "use": "pensil-usage",
  "viewBox": "0 0 12.817 15.98",
  "content": "<symbol viewBox=\"0 0 12.817 15.98\" id=\"pensil\"><path d=\"M11.648.579c-1.3-.96-3.091-.7-4.06.59l-6.67 8.97c-.14.181-.23.42-.28.65l-.63 4.471c-.04.209.07.459.25.6.15.1.31.13.46.119.06-.02.13-.029.16-.049l4.1-1.871c.21-.1.43-.25.56-.449l6.7-8.97c.96-1.281.7-3.091-.59-4.061M1.388 14.308l.39-2.709 2.11 1.569-2.5 1.14zm9.89-10.399l-.42.52-2.65-1.99.39-.52c.279-.37.66-.6 1.1-.65.41-.06.859.04 1.23.3.359.26.58.65.649 1.1.061.45-.049.88-.299 1.24\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/pensil.svg
// module id = 176
// module chunks = 0